/* eslint-disable consistent-return */
import * as React from "react";

type MutationObserverHook<T = HTMLElement | undefined> = (
  ref: React.MutableRefObject<T>,
  callback: MutationCallback,
  options?: MutationObserverInit
) => void;

const useMutationObserver: MutationObserverHook = (
  ref,
  callback,
  options = {
    childList: true,
  }
) => {
  React.useEffect(() => {
    if (ref.current) {
      const observer = new MutationObserver(callback);
      observer.observe(ref.current, options);
      return () => observer.disconnect();
    }
  }, [callback, options, ref]);
};

export default useMutationObserver;
